import { render, staticRenderFns } from "./PageTitleView.vue?vue&type=template&id=0e6134fd"
import script from "./PageTitleView.vue?vue&type=script&lang=ts"
export * from "./PageTitleView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports